import * as actions from "@/AppRedux/actions/admin/hotelList/hotelListType";

export type ProcessTypes = {
    status: boolean;
    action:
        | "GET_HOTEL_LIST_REQUEST"
        | "GET_HOTEL_PROFILE_REQUEST"
        | "CREATE_HOTEL_PROFILE_REQUEST"
        | "UPDATE_HOTEL_PROFILE_REQUEST"
        | null;
    message?: string | null;
};

type InitialStateType = {
    process: ProcessTypes;
    loading: boolean;
    hotelList: actions.HotelListItem[];
    hotelProfileData: actions.HotelProfileData | null;
    error: string | null;
}

const INIT_STATE: InitialStateType = {
    process: {
        status: false,
        action: null,
        message: null,
    },
    loading: false,
    hotelList: [],
    hotelProfileData: null,
    error: null
};

const hotelListReducer = (state = INIT_STATE, action: actions.HotelListAction): InitialStateType => {
    switch (action.type) {
        case actions.GET_HOTEL_LIST_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
                process: INIT_STATE.process
            };
        case actions.GET_HOTEL_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                hotelList: action.payload,
                process: {
                    status: true,
                    action: "GET_HOTEL_LIST_REQUEST",
                    message: "Content loaded successfully",
                },
            };
        case actions.GET_HOTEL_LIST_FAILED:
            return {
                ...state,
                loading: false,
                hotelList: [],
                error: action.payload,
                process: {
                    status: false,
                    action: "GET_HOTEL_LIST_REQUEST",
                    message: action.payload,
                },
            };
        case actions.GET_HOTEL_PROFILE_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
                hotelProfileData: null,
                process: INIT_STATE.process
            };
        case actions.GET_HOTEL_PROFILE_SUCCESS:
            return {
                ...state,
                loading: false,
                hotelProfileData: action.payload,
                process: {
                    status: true,
                    action: "GET_HOTEL_PROFILE_REQUEST",
                    message: "Hotel profile loaded successfully",
                },
            };
        case actions.GET_HOTEL_PROFILE_FAILED:
            return {
                ...state,
                loading: false,
                hotelProfileData: null,
                error: action.payload,
                process: {
                    status: false,
                    action: "GET_HOTEL_PROFILE_REQUEST",
                    message: action.payload,
                },
            };
        case actions.CREATE_HOTEL_PROFILE_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
                process: INIT_STATE.process
            };
        case actions.CREATE_HOTEL_PROFILE_SUCCESS:
            return {
                ...state,
                loading: false,
                process: {
                    status: true,
                    action: "CREATE_HOTEL_PROFILE_REQUEST",
                    message: "Hotel profile created successfully",
                },
            };
        case actions.CREATE_HOTEL_PROFILE_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload,
                process: {
                    status: false,
                    action: "CREATE_HOTEL_PROFILE_REQUEST",
                    message: action.payload,
                },
            };
        case actions.UPDATE_HOTEL_PROFILE_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
                process: INIT_STATE.process
            };
        case actions.UPDATE_HOTEL_PROFILE_SUCCESS:
            return {
                ...state,
                loading: false,
                process: {
                    status: true,
                    action: "UPDATE_HOTEL_PROFILE_REQUEST",
                    message: "Hotel profile updated successfully",
                },
            };
        case actions.UPDATE_HOTEL_PROFILE_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload,
                process: {
                    status: false,
                    action: "UPDATE_HOTEL_PROFILE_REQUEST",
                    message: action.payload,
                },
            };
        case actions.UPDATE_HOTEL_PROFILE_ENABLED_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
                hotelList: state.hotelList.map(hotel =>
                    hotel.id === action.payload.id ? { ...hotel, active: action.payload.active } : hotel
                ),
                process: {
                    status: false,
                    action: "UPDATE_HOTEL_PROFILE_REQUEST",
                    message: null
                }
            };
        case actions.UPDATE_HOTEL_PROFILE_ENABLED_SUCCESS:
            return {
                ...state,
                loading: false,
                process: {
                    status: true,
                    action: "UPDATE_HOTEL_PROFILE_REQUEST",
                    message: "Updated active status successfully",
                },
            };
        case actions.UPDATE_HOTEL_PROFILE_ENABLED_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload.message,
                hotelList: state.hotelList.map(hotel =>
                    hotel.id === action.payload.id ? { ...hotel, active: !hotel.active } : hotel
                ),
                process: {
                    status: false,
                    action: "UPDATE_HOTEL_PROFILE_REQUEST",
                    message: action.payload.message,
                },
            };
        case actions.GET_HOTEL_LIST_PROCESS_CLEAR:
            return {
                ...state,
                loading: false,
                error: null,
                process: INIT_STATE.process
            };
        default:
            return state;
    }
};

export default hotelListReducer;
